<template>
  <v-dialog
    content-class="dialog-custom"
    v-model="dialog"
    persistent
    max-width="100%"
  >
      <v-card light>
        <div style = "position: absolute; right: 0;">
            <v-btn
              class="mx-2"
              icon
              title="Close Form"
              @click="handleDialogClose"
            >
              <v-icon dark>
                fas fa-times
              </v-icon>
            </v-btn>
          </div>
      <v-card-title style=" word-break: normal">
        <div style = "position: relative;" class="dialog-header-custom">
          <div style="width: 100%">
            <paymentComponent
            :customProps="customProp"
            :minimumAmount="5000"
            :hideBankTransfer="hideBankTransfer"
            :transactionPurpose="transactionPurpose"
            :selectedPortfolio="selectedPortfolio"
            :isFirstTime = "false"
            />
          </div>
        </div>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import paymentComponent from '../paymentComponent/paymentComponent.vue'
export default {
    name: 'paymentDialog',
    components: {
        paymentComponent
    },
    props: {
        showPaymentDialog: Boolean,
        selectedPortfolio: Object,
        transactionPurpose: String
    },
    data () {
        return {
            dialog: this.showPaymentDialog,
            customProp: {
                hideBackButton: true,
                investmentAmount: this.selectedPortfolio.investmentAmount / 100
            },
            hideBankTransfer: true
        }
    },
    methods: {
        handleDialogClose () {
            this.$emit('closeDialog')
        }
    }
}
</script>
<style lang="scss" scoped>
.v-card__title {
  line-height: 24px
}
.dialog-custom {
  background: #ffffff;
  border: 1px solid #b9b9bb !important;
  box-sizing: border-box !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 20px !important;

  .v-card__actions {
    padding: 20px !important;
  }
}

.v-text-field .v-label {
  font-weight: bold !important;
}
.dialog-header-custom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.custom-btn-common {
  width: 150px;
  font-size: 14px;
  text-transform: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;
}

.custom-btn {
  background-color: #ffcb05 !important;
  font-size: 14px;
  text-transform: none;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;

  .v-icon {
    font-size: 14px;
    margin-left: 16px;
  }
}

@media (max-width: 990px) {
  ::v-deep .v-dialog {
    min-width: 98% !important;
  }
}
</style>
